import Vue from 'vue';

export const EventBus = new Vue();

export const EVENTS = {
    START_QUIZ:'START_QUIZ',
    CLOSE_MENU:'CLOSE_MENU',
    FAKE_RESIZE: 'FAKE_RESIZE',
    LOADER_HIDE_ENTIRE_PAGE:'LOADER_HIDE_ENTIRE_PAGE'
}